import './styles/reset.less';
import './styles/fonts.less';
import './styles/atomic.less';
import './styles/base.less';

import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import 'utils/sentry';

// Scrolling
import ScrollProvider from 'helpers/ScrollProvider';

import App from './App';

const Wrapper = () => (
  <BrowserRouter>
    <HelmetProvider>
      <ScrollProvider>
        <App />
      </ScrollProvider>
    </HelmetProvider>
  </BrowserRouter>
);

ReactDOM.render(<Wrapper />, document.getElementById('root'));
